// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pqg83A9mnSHDOE6iVuyj {
  position: relative;
  overflow: hidden;
  padding: 8px 6px 6px 6px;
  box-sizing: border-box;
  transition: grid-template-rows 0.3s ease, grid-template-columns 0.3s ease;
}

.htlNpR3IAVSImMDi81dO {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  min-width: 0;
  background: var(--vnsc-bg-primary, #131722);
  border-radius: 4px;
  overflow: visible;
  box-sizing: border-box;
  transition: z-index 0.1s ease;
}

/* Ring overlay: outline/box-shadow đều vẽ DƯỚI con có position/z-index
   (header che mất cạnh trên), nên ring là 1 div riêng phủ trên cùng:
   absolute inset-0, pointer-events none, z-index trên mọi content. */
.GRPmMZsDM3h6KKzbyraM {
  position: absolute;
  /* Nở ra NGOÀI 2px mỗi cạnh: khung tách khỏi nội dung, có khoảng thở.
     Là overlay (pointer-events:none) nên không chiếm layout, không xô lưới
     (khác border cũ đổi box size). */
  inset: -2px;
  border: 1px solid transparent;
  border-radius: 6px;
  pointer-events: none;
  /* Trên .rsc-pane-wrap (z-40) của khung chart — nếu thấp hơn, cạnh trên
     (và mọi cạnh dưới content đặc) bị che. Splitters (z-20) vẫn dưới ring
     nhưng ring pointer-events:none nên không ảnh hưởng kéo thả. */
  z-index: 50;
  transition: border-color 0.2s ease;
}

.htlNpR3IAVSImMDi81dO:hover .GRPmMZsDM3h6KKzbyraM {
  border-color: var(--vnsc-border-hover, #3a3e49);
}

.htlNpR3IAVSImMDi81dO.CmI1qmawHz2C4H2ucfF_ {
  z-index: 10;
}

.htlNpR3IAVSImMDi81dO.CmI1qmawHz2C4H2ucfF_ .GRPmMZsDM3h6KKzbyraM {
  border: 2px solid var(--vnsc-primary, #2962ff);
}

.htlNpR3IAVSImMDi81dO:focus-visible .GRPmMZsDM3h6KKzbyraM {
  border: 2px solid var(--vnsc-primary, #2962ff);
}

.AtIjO479N3UOs3YFzLlL {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -4px;
  height: 10px;
  cursor: row-resize;
  background: transparent;
  z-index: 20;
  touch-action: none;
}

.AtIjO479N3UOs3YFzLlL::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: var(--splitter-color, rgba(255, 255, 255, 0.14));
  transform: translateY(-50%);
  transition: background-color 0.2s ease;
}

.AtIjO479N3UOs3YFzLlL:hover::before {
  background: var(--splitter-color-hover, rgba(255, 255, 255, 0.25));
  height: 1px;
}

.AtIjO479N3UOs3YFzLlL.tD9JVVIXtmSUJiAkuNQF::before {
  background: var(--vnsc-primary, #2962ff);
  height: 2px;
}

.W6R59xylVHnZsDg6BUGU {
  position: absolute;
  top: 0;
  bottom: 0;
  right: -4px;
  width: 10px;
  cursor: col-resize;
  background: transparent;
  z-index: 20;
  touch-action: none;
}

.W6R59xylVHnZsDg6BUGU::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 1px;
  background: var(--splitter-color, rgba(255, 255, 255, 0.14));
  transform: translateX(-50%);
  transition: background-color 0.2s ease;
}

.W6R59xylVHnZsDg6BUGU:hover::before {
  background: var(--splitter-color-hover, rgba(255, 255, 255, 0.25));
  width: 1px;
}

.W6R59xylVHnZsDg6BUGU.tD9JVVIXtmSUJiAkuNQF::before {
  background: var(--vnsc-primary, #2962ff);
  width: 2px;
}

/* Dark theme support */
[data-chart-mode="dark"] .htlNpR3IAVSImMDi81dO {
  background: var(--vnsc-bg-primary, #131722);
}

[data-chart-mode="dark"] .AtIjO479N3UOs3YFzLlL::before,
[data-chart-mode="dark"] .W6R59xylVHnZsDg6BUGU::before {
  background: var(--splitter-color-dark, rgba(255, 255, 255, 0.12));
}

[data-chart-mode="dark"] .AtIjO479N3UOs3YFzLlL:hover::before,
[data-chart-mode="dark"] .W6R59xylVHnZsDg6BUGU:hover::before {
  background: var(--splitter-color-hover-dark, rgba(255, 255, 255, 0.25));
}

[data-chart-mode="dark"] .AtIjO479N3UOs3YFzLlL.tD9JVVIXtmSUJiAkuNQF::before,
[data-chart-mode="dark"] .W6R59xylVHnZsDg6BUGU.tD9JVVIXtmSUJiAkuNQF::before {
  background: var(--vnsc-primary, #2962ff);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .AtIjO479N3UOs3YFzLlL,
  .W6R59xylVHnZsDg6BUGU {
    width: 12px;
    height: 12px;
  }
  
  .AtIjO479N3UOs3YFzLlL::before {
    height: 3px;
  }
  
  .W6R59xylVHnZsDg6BUGU::before {
    width: 3px;
  }
}

/* Focus styles for accessibility — ring phủ trên cùng vẽ qua .activeRing. */
.htlNpR3IAVSImMDi81dO:focus-within {
  outline: none;
}

.htlNpR3IAVSImMDi81dO.CmI1qmawHz2C4H2ucfF_:focus-within {
  outline: none;
}

.htlNpR3IAVSImMDi81dO:focus-visible {
  outline: none;
}

.AtIjO479N3UOs3YFzLlL:focus,
.W6R59xylVHnZsDg6BUGU:focus {
  outline: 1px solid var(--vnsc-primary, #2962ff);
  outline-offset: -1px;
}

/* High contrast mode */
@media (prefers-contrast: high) {
  /* Ring phủ .activeRing đã đủ tương phản, không vẽ thêm outline chồng. */
  .AtIjO479N3UOs3YFzLlL::before,
  .W6R59xylVHnZsDg6BUGU::before {
    background: currentColor;
  }
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .htlNpR3IAVSImMDi81dO,
  .AtIjO479N3UOs3YFzLlL::before,
  .W6R59xylVHnZsDg6BUGU::before {
    transition: none;
  }
}
/*
 * Empty-grid-slot affordance (F-08, PRO audit 2026-10-15).
 *
 * This used to be an inline style with a hardcoded white border and white "+" glyph:
 *   border: 2px dashed rgba(255,255,255,0.15) / color: rgba(255,255,255,0.3)
 * The light theme sets \`--vnsc-bg-primary: #ffffff\` (injected.css:3161), so the button
 * rendered white-on-white and was effectively invisible — on the one control that adds a
 * chart to an empty slot. Inline styles bypass the token layer, which is why nothing in the
 * theme switch could reach it.
 *
 * Tokens carry the theme. Each has a dark default in the \`var(..., fallback)\` position,
 * matching the convention already used by \`.slot\` above.
 */
.ffKueWKFLQAY0ILOjWIz {
  border: 2px dashed var(--vnsc-border-hover, #3a3e49);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  min-height: 60px;
  color: var(--vnsc-text-secondary, #787b86);
}

.ffKueWKFLQAY0ILOjWIz:hover,
.ffKueWKFLQAY0ILOjWIz:focus-visible {
  border-color: var(--vnsc-text-secondary, #787b86);
  color: var(--vnsc-text-primary, #d1d4dc);
}

.ffKueWKFLQAY0ILOjWIz:focus-visible {
  outline: 2px solid var(--vnsc-text-link, #3b82f6);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/widget/components/layout/GridContainer.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;EACtB,yEAAyE;AAC3E;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;qEAEqE;AACrE;EACE,kBAAkB;EAClB;;qCAEmC;EACnC,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB;;kEAEgE;EAChE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,kEAAkE;EAClE,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,SAAS;EACT,UAAU;EACV,4DAA4D;EAC5D,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,kEAAkE;EAClE,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,UAAU;AACZ;;AAEA,uBAAuB;AACvB;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,iEAAiE;AACnE;;AAEA;;EAEE,uEAAuE;AACzE;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA,2BAA2B;AAC3B;EACE;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA,4EAA4E;AAC5E;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,wEAAwE;EACxE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA,mBAAmB;AACnB;EACE;;;IAGE,gBAAgB;EAClB;AACF;AACA;;;;;;;;;;;;EAYE;AACF;EACE,oDAAoD;EACpD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;;EAEE,iDAAiD;EACjD,wCAAwC;AAC1C;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;AACrB","sourcesContent":[".gridContainer {\r\n  position: relative;\r\n  overflow: hidden;\r\n  padding: 8px 6px 6px 6px;\r\n  box-sizing: border-box;\r\n  transition: grid-template-rows 0.3s ease, grid-template-columns 0.3s ease;\r\n}\r\n\r\n.slot {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  min-height: 0;\r\n  min-width: 0;\r\n  background: var(--vnsc-bg-primary, #131722);\r\n  border-radius: 4px;\r\n  overflow: visible;\r\n  box-sizing: border-box;\r\n  transition: z-index 0.1s ease;\r\n}\r\n\r\n/* Ring overlay: outline/box-shadow đều vẽ DƯỚI con có position/z-index\r\n   (header che mất cạnh trên), nên ring là 1 div riêng phủ trên cùng:\r\n   absolute inset-0, pointer-events none, z-index trên mọi content. */\r\n.activeRing {\r\n  position: absolute;\r\n  /* Nở ra NGOÀI 2px mỗi cạnh: khung tách khỏi nội dung, có khoảng thở.\r\n     Là overlay (pointer-events:none) nên không chiếm layout, không xô lưới\r\n     (khác border cũ đổi box size). */\r\n  inset: -2px;\r\n  border: 1px solid transparent;\r\n  border-radius: 6px;\r\n  pointer-events: none;\r\n  /* Trên .rsc-pane-wrap (z-40) của khung chart — nếu thấp hơn, cạnh trên\r\n     (và mọi cạnh dưới content đặc) bị che. Splitters (z-20) vẫn dưới ring\r\n     nhưng ring pointer-events:none nên không ảnh hưởng kéo thả. */\r\n  z-index: 50;\r\n  transition: border-color 0.2s ease;\r\n}\r\n\r\n.slot:hover .activeRing {\r\n  border-color: var(--vnsc-border-hover, #3a3e49);\r\n}\r\n\r\n.slot.active {\r\n  z-index: 10;\r\n}\r\n\r\n.slot.active .activeRing {\r\n  border: 2px solid var(--vnsc-primary, #2962ff);\r\n}\r\n\r\n.slot:focus-visible .activeRing {\r\n  border: 2px solid var(--vnsc-primary, #2962ff);\r\n}\r\n\r\n.rowSplitter {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: -4px;\r\n  height: 10px;\r\n  cursor: row-resize;\r\n  background: transparent;\r\n  z-index: 20;\r\n  touch-action: none;\r\n}\r\n\r\n.rowSplitter::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 0;\r\n  right: 0;\r\n  height: 1px;\r\n  background: var(--splitter-color, rgba(255, 255, 255, 0.14));\r\n  transform: translateY(-50%);\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.rowSplitter:hover::before {\r\n  background: var(--splitter-color-hover, rgba(255, 255, 255, 0.25));\r\n  height: 1px;\r\n}\r\n\r\n.rowSplitter.dragging::before {\r\n  background: var(--vnsc-primary, #2962ff);\r\n  height: 2px;\r\n}\r\n\r\n.colSplitter {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: -4px;\r\n  width: 10px;\r\n  cursor: col-resize;\r\n  background: transparent;\r\n  z-index: 20;\r\n  touch-action: none;\r\n}\r\n\r\n.colSplitter::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 1px;\r\n  background: var(--splitter-color, rgba(255, 255, 255, 0.14));\r\n  transform: translateX(-50%);\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.colSplitter:hover::before {\r\n  background: var(--splitter-color-hover, rgba(255, 255, 255, 0.25));\r\n  width: 1px;\r\n}\r\n\r\n.colSplitter.dragging::before {\r\n  background: var(--vnsc-primary, #2962ff);\r\n  width: 2px;\r\n}\r\n\r\n/* Dark theme support */\r\n[data-chart-mode=\"dark\"] .slot {\r\n  background: var(--vnsc-bg-primary, #131722);\r\n}\r\n\r\n[data-chart-mode=\"dark\"] .rowSplitter::before,\r\n[data-chart-mode=\"dark\"] .colSplitter::before {\r\n  background: var(--splitter-color-dark, rgba(255, 255, 255, 0.12));\r\n}\r\n\r\n[data-chart-mode=\"dark\"] .rowSplitter:hover::before,\r\n[data-chart-mode=\"dark\"] .colSplitter:hover::before {\r\n  background: var(--splitter-color-hover-dark, rgba(255, 255, 255, 0.25));\r\n}\r\n\r\n[data-chart-mode=\"dark\"] .rowSplitter.dragging::before,\r\n[data-chart-mode=\"dark\"] .colSplitter.dragging::before {\r\n  background: var(--vnsc-primary, #2962ff);\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .rowSplitter,\r\n  .colSplitter {\r\n    width: 12px;\r\n    height: 12px;\r\n  }\r\n  \r\n  .rowSplitter::before {\r\n    height: 3px;\r\n  }\r\n  \r\n  .colSplitter::before {\r\n    width: 3px;\r\n  }\r\n}\r\n\r\n/* Focus styles for accessibility — ring phủ trên cùng vẽ qua .activeRing. */\r\n.slot:focus-within {\r\n  outline: none;\r\n}\r\n\r\n.slot.active:focus-within {\r\n  outline: none;\r\n}\r\n\r\n.slot:focus-visible {\r\n  outline: none;\r\n}\r\n\r\n.rowSplitter:focus,\r\n.colSplitter:focus {\r\n  outline: 1px solid var(--vnsc-primary, #2962ff);\r\n  outline-offset: -1px;\r\n}\r\n\r\n/* High contrast mode */\r\n@media (prefers-contrast: high) {\r\n  /* Ring phủ .activeRing đã đủ tương phản, không vẽ thêm outline chồng. */\r\n  .rowSplitter::before,\r\n  .colSplitter::before {\r\n    background: currentColor;\r\n  }\r\n}\r\n\r\n/* Reduced motion */\r\n@media (prefers-reduced-motion: reduce) {\r\n  .slot,\r\n  .rowSplitter::before,\r\n  .colSplitter::before {\r\n    transition: none;\r\n  }\r\n}\r\n/*\r\n * Empty-grid-slot affordance (F-08, PRO audit 2026-10-15).\r\n *\r\n * This used to be an inline style with a hardcoded white border and white \"+\" glyph:\r\n *   border: 2px dashed rgba(255,255,255,0.15) / color: rgba(255,255,255,0.3)\r\n * The light theme sets `--vnsc-bg-primary: #ffffff` (injected.css:3161), so the button\r\n * rendered white-on-white and was effectively invisible — on the one control that adds a\r\n * chart to an empty slot. Inline styles bypass the token layer, which is why nothing in the\r\n * theme switch could reach it.\r\n *\r\n * Tokens carry the theme. Each has a dark default in the `var(..., fallback)` position,\r\n * matching the convention already used by `.slot` above.\r\n */\r\n.emptySlot {\r\n  border: 2px dashed var(--vnsc-border-hover, #3a3e49);\r\n  border-radius: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  min-height: 60px;\r\n  color: var(--vnsc-text-secondary, #787b86);\r\n}\r\n\r\n.emptySlot:hover,\r\n.emptySlot:focus-visible {\r\n  border-color: var(--vnsc-text-secondary, #787b86);\r\n  color: var(--vnsc-text-primary, #d1d4dc);\r\n}\r\n\r\n.emptySlot:focus-visible {\r\n  outline: 2px solid var(--vnsc-text-link, #3b82f6);\r\n  outline-offset: 2px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridContainer": `pqg83A9mnSHDOE6iVuyj`,
	"slot": `htlNpR3IAVSImMDi81dO`,
	"activeRing": `GRPmMZsDM3h6KKzbyraM`,
	"active": `CmI1qmawHz2C4H2ucfF_`,
	"rowSplitter": `AtIjO479N3UOs3YFzLlL`,
	"dragging": `tD9JVVIXtmSUJiAkuNQF`,
	"colSplitter": `W6R59xylVHnZsDg6BUGU`,
	"emptySlot": `ffKueWKFLQAY0ILOjWIz`
};
export default ___CSS_LOADER_EXPORT___;
